// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiDropCuration {
    'drop_included': boolean;
    'authenticated_user_can_curate': boolean;
    'id': string;
    'name': string;
    'wave_id': string;
    'group_id': string;
    'created_at': number;
    'updated_at': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "drop_included",
            "baseName": "drop_included",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "authenticated_user_can_curate",
            "baseName": "authenticated_user_can_curate",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "wave_id",
            "baseName": "wave_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "group_id",
            "baseName": "group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiDropCuration.attributeTypeMap;
    }

    public constructor() {
    }
}
